module.exports = __webpack_public_path__ + "img/bwtext.620efb97.svg";